import { UserWithMyRooms } from "@api/src/types/user";
import type { User } from "@prisma/client";

export const getUserInitials = (user: Pick<User | UserWithMyRooms, "firstName" | "lastName"> | null) => {
  return `${user?.firstName?.[0]?.toUpperCase()}${user?.lastName?.[0]?.toUpperCase()}`;
};
